import * as axios from 'axios';
import * as TYPES from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchErrorMessages = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGES,
    payload,
  };
};

export const dispatchSuccessMessages = (payload) => {
  return {
    type: TYPES.SET_SUCCESS_MESSAGES,
    payload,
  };
};

export const setDetailErrorMessages = (payload) => {
  return {
    type: TYPES.SET_DETAIL_ERROR_MESSAGES,
    payload,
  };
};

export const setDetailSuccessMessages = (payload) => {
  return {
    type: TYPES.SET_DETAIL_SUCCESS_MESSAGES,
    payload,
  };
};

export const setCGPSearchValues = (payload) => {
  return {
    type: TYPES.SET_CGP_SEARCH_VALUES,
    payload,
  };
};

export const dispatchAllRebateProgramCode = (payload) => {
  return {
    type: TYPES.GET_ALL_REBATE_PROGRAMS_CGPS,
    payload,
  };
};

export const setNewCGPDetailRowData = (payload) => {
  return {
    type: TYPES.GET_DETAIL_TABLE_DATA,
    payload,
  };
};

export const setShoWAllHistoryValue = (payload) => {
  return {
    type: TYPES.SET_SHOW_ALL_HISTORY,
    payload,
  };
};

export const setTableAdd = (payload) => {
  return {
    type: TYPES.SET_TABLE_ADD,
    payload,
  };
};

export const setTableEdit = (payload) => {
  return {
    type: TYPES.SET_TABLE_EDIT,
    payload,
  };
};

export const setTableEditedData = (payload) => {
  return {
    type: TYPES.SET_TABLE_EDITED_DATA,
    payload,
  };
};

export const setDeleteRowIndex = (payload) => {
  return {
    type: TYPES.DELETE_ROW_INDEX,
    payload,
  };
};

export const deleteCGPRow = (rowIndex) => {
  return (dispatch, getState) => {
    const dataList = [...getState().sharedState.CGPReducer.detailTableData];
    dataList[rowIndex].deleteRecord = true;
    dispatch(setNewCGPDetailRowData(dataList));
  };
};

export const addNewRowData = (payload, action) => {
  return (dispatch, getState) => {
    const dataList = [...getState().sharedState.CGPReducer.detailTableData];
    if (Array.isArray(payload) && payload && payload.length > 0) {
      dispatch(setNewCGPDetailRowData(payload));
    } else {
      const temp = [...dataList];
      temp.unshift(payload);
      dispatch(setNewCGPDetailRowData(temp));
    }
  };
};

export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const getClaimGrouping = (values) => async (dispatch) => {
  return await axios
    .post(`${serviceEndPoint.GET_CLAIM_GROUPING}`, values)
    .then((response) => {
      return dispatch(
        setNewCGPDetailRowData(
          response.data?.map((item) => ({
            ...item,
            startQtr: item.rpcClaimGroupingParamPK.startQtr,
            groupingColumnValue:
              item.rpcClaimGroupingParamPK.groupingColumnValue,
            newOrUpdateRecord: false,
          }))
        )
      );
    })
    .catch((response) => {
      return dispatch(setNewCGPDetailRowData([]));
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: TYPES.SET_DEFAULT_QTR,
    payload: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};

export const setStoredGroupingColumns = (data) => {
  return {
    type: TYPES.SET_STORED_GROUPING_COLUMNS,
    payload: data,
  };
};

export const getRpcClaimGroupingParam = (values) => async (dispatch) => {
  return await axios
    .post(`${serviceEndPoint.GET_RPC_CLAIM_GROUPING_PARAM}`, values)
    .then((response) => {
      return dispatch(setStoredGroupingColumns(response.data));
    })
    .catch((response) => {
      return dispatch(setStoredGroupingColumns([]));
    });
};

export const saveClaimGrouping = (values) => async (dispatch) => {
  return await axios
    .post(`${serviceEndPoint.SAVE_CLAIM_GROUPING}`, values)
    .then((response) => {
      return response.data ?? true;
    })
    .catch((response) => {
      return false;
    });
};

export const changeFieldValidationClaimGroup = (values) => async (dispatch) => {
  return await axios
    .post(`${serviceEndPoint.CHANGE_FIELD_VALIDATION_CLIAM_GROUP}`, values)
    .then((response) => {
      return response.data;
    })
    .catch(({ response }) => {
      return response.data;
    });
};

export const deleteRpcClaimGroupParam = (values) => async (dispatch) => {
  return await axios
    .post(`${serviceEndPoint.DELETE_RPC_CLAIM_GROUP_PARAM}`, values)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return response.data;
    });
};

export const updateRpcClaimGroupingParam = (values) => async (dispatch) => {
  return await axios
    .post(`${serviceEndPoint.UPDATE_RPC_CLAIM_GROUPING_PARAM}`, values)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return response.data;
    });
};

export const resetRequestCGPStore = () => {
  return {
    type: TYPES.RESET_REQUEST_CGP_STORE,
  };
};

export const resetCGPDetailStore = () => {
  return {
    type: TYPES.RESET_CGP_DETAIL_STORE,
  };
};

export const setValidateTrigger = (payload) => {
  return {
    type: TYPES.SET_VALIDATE_TRIGGER,
    payload,
  };
};
